import { ServicesUI } from "../../components/services/ServicesUI";
import { useServicesData } from "../../hooks/useServicesData";
import "../../css/services.css";

const FreelancersPage = () => {
    const servicesData = useServicesData("freelancer");

    return (
        <ServicesUI
            {...servicesData}
            pageTitle="Freelancers"
        />
    );
};

export default FreelancersPage;